import { useEffect, useState } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../../api';

const useProductQuantitiesChanges = (collectionName, arrayFieldName) => {
  const [productId, setProductId] = useState(null);
  const [quantities, setQuantities] = useState(null);

  let unsubscribe;
  useEffect(() => {
    const listener = () => {
      const q = query(collection(db, collectionName));

      unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const documentData = change.doc.data();
          const arrayData = documentData[arrayFieldName];
          setProductId(documentData.id);
          setQuantities(arrayData.map(item=>{return {...item, date: item.date.toDate()}}));
          // console.log('PRODUCT HAS CHANGED', documentData.id)
        });
      });
    };
    console.log('*** LISTENER FOR PRODUCT QUANTITES ON ***');
    listener();
    return () => unsubscribe();
  }, [collectionName, arrayFieldName]);

  return { productId, quantities };
};

export default useProductQuantitiesChanges;
